<sim-base-chip-input
	[formState]="checklistFc"
	[label]="label"
	[placeholder]="placeholder"
	[isMultiSelect]="canSelectMultipleChecklists"
	[autoCompleteValues]="autoCompleteData"
	[debounceConfig]="{time: 200}"
	[isDisabled]="isDisabled"
	(searchFieldChanged)="reloadAutoCompleteData($event)"
	(optionSelected)="optionSelected.emit($event)"
>
	<ng-container labelSuffix>
		<ng-content select="[labelSuffix]" />
	</ng-container>
</sim-base-chip-input>
